import video from './preview.mp4';

export const experience = [
  {
    title: 'Software Engineer Intern',
    company: 'Torre.ai',
    from: 'Apr 2023',
    to: 'Dec 2023',
    description: ['- Enhanced, updated, tested, documented, and wrote platform components package.',
      '- Major high-scale component package refactoring reducing code duplication, increasing components performance, usability, documenting, and testing.',
      '- Had a major role in the addition of the Storybooks components documentation tool.',
      '- Migrated components from JS to TS.',
      '- 100+ cards successfully closed on reported bugs in less than a year.',
      '- Contribute to multiple microservices in a variety of programming tools.',
      '- Collaborated with cross-functional teams, including designers and product managers, to ensure alignment and deliver high-quality software.'],
    tech: ['Vue', 'TypeScript', 'Microservices', 'StoryBooks'],
    linkToCompany: 'https://torre.ai/',
  },
  {
    title: 'Web Development Intern',
    company: 'SYNTONEX',
    from: 'Oct 2022',
    to: 'Dec 2022',
    description: ["- Developed and implemented student's data visualization pages.",
      '- Built a navigation system that allowed users to navigate between multiple platform tools.',
      '- Implemented responsiveness and made pages of the product accessible to mobile users.'],
    tech: ['PHP', 'JavaScript', 'CSS', 'HTML'],
  },
];

export const project = [
  {
    title: 'Money Flow',
    company: 'Freelance',
    from: 'may 2024',
    to: 'present',
    description:
      'The Transaction Tracker Full Stack Application is designed to help users manage and analyze their financial transactions. This application allows users to list all their transactions, providing detailed information and analysis for better financial management. It features comparative analysis for the last two months, an annual overview graph, and calculates the influence percentage of each individual transaction on the overall financial status.',
    tech: ['RESTapi', 'RoR', 'React.js'],
    video,
  },
];
